import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP: {
            fullname: '',//用户姓名
            usertype: '',//用户类型
            organizationid: '',//所属组织
        },
        list: [], //table中的list显示数据
        pagination: {}, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            // console.log(action, "commit")
            // state = { ...state, ...action.payload }   //这么写不行，必须要遍历挨个重新赋值
            // state.domainnameSelectOptions = action.payload.domainnameSelectOptions
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
            // console.log(state, " yo ?") //跟console.log({ ...state, ...action.payload }) 的值是不一样的, 所以不能直接用展开运算符
        }
    },


    actions: {
        //查询
        selectPlatFromConfig(context, payload) {
            payload.type = 'ums/searchPlatFromConfig'
            return D.select({
                ...payload
            })

        },
        //新增
        insertPlatFromConfig(context, payload) {
            payload.type = 'ums/insertPlatFromConfig'
            return D.del({
                ...payload
            })
        },
        //修改
        editPlatFromConfig(context, payload) {
            payload.type = 'ums/editPlatFromConfig'
            return D.del({
                ...payload
            })
        },
        //导出菜单
        menuExport(context, payload) {
            payload.type = 'ums/menuExport'
            return D.select({
                ...payload
            })
        },
        //导入菜单
        menuImport(context, payload) {
            payload.type = 'ums/menuImport'
            return D.select({
                ...payload
            })
        },
        //平台注册用户
        registerUser(context, payload) {
            payload.type = 'ums/registerUser'
            return D.del({
                ...payload
            })
        },
        //查询菜单树的结构
        searchMenuConfigTree(context, payload) {
            payload.type = 'ums/searchMenuConfigTree'
            return D.select({
                ...payload
            })

        },
        //新增菜单
        insertMenuConfig(context, payload) {
            payload.type = 'ums/insertMenuConfig'
            return D.select({
                ...payload
            })
        },
        //修改菜单
        updateMenuConfig(context, payload) {
            payload.type = 'ums/updateMenuConfig'
            return D.select({
                ...payload
            })
        },

        //删除菜单
        deleteMenuConfig(context, payload) {
            payload.type = 'ums/deleteMenuConfig'
            return D.select({
                ...payload
            })
        },
        //查询角色
        searchRoleConfig(context, payload) {
            payload.type = 'ums/searchRoleConfig'
            return D.select({
                ...payload
            })
        },
        //查询角色
        searchRoleConfigPage(context, payload) {
            payload.type = 'ums/searchRoleConfigPage'
            return D.select({
                ...payload
            })
        },
        searchUserList(context, payload) {
            payload.type = 'ums/searchUserList'
            return D.select({
                ...payload
            })
        },
        //新增角色
        insertRoleConfig(context, payload) {
            payload.type = 'ums/insertRoleConfig'
            return D.select({
                ...payload
            })
        },
        //更新角色
        updateRoleConfig(context, payload) {
            payload.type = 'ums/updateRoleConfig'
            return D.select({
                ...payload
            })
        },
        //查询用户与授权信息
        searchUserAndAuth(context, payload) {
            payload.type = 'ums/searchUserAndAuth'
            return D.select({
                ...payload
            })
        },
        updateUserAuth(context, payload) {
            payload.type = 'ums/updateUserAuth'
            return D.select({
                ...payload
            })
        },

        updateUser(context, payload) {
            payload.type = 'ums/updateUser'
            return D.select({
                ...payload
            })
        },
        //查询用户角色以用户维度
        searchUserRolesByUser(context, payload) {
            payload.type = 'ums/searchUserRolesByUser'
            return D.select({
                ...payload
            })
        },
        //修改磐石用户详情
        updateUMSUserDetail(context, payload) {
            payload.type = 'ums/updateUMSUserDetail'
            return D.select({
                ...payload
            })
        },
        searchUMSUserDetail(context, payload) {
            payload.type = 'ums/searchUMSUserDetail'
            return D.select({
                ...payload
            })
        },
        //查询用户角色
        searchUserRoles(context, payload) {
            payload.type = 'ums/searchUserRoles'
            return D.select({
                ...payload
            })
        },
        //新增用户角色
        insertUserRole(context, payload) {
            payload.type = 'ums/insertUserRole'
            return D.select({
                ...payload
            })
        },
        //更新用户角色
        updateUserRole(context, payload) {
            payload.type = 'ums/updateUserRole'
            return D.select({
                ...payload
            })
        }, //删除角色
        deleteUserRole(context, payload) {
            payload.type = 'ums/deleteUserRole'
            return D.select({
                ...payload
            })
        },


        selectOrgList(context, payload) {
            return D.select({
                ...payload
            })
        },
        selectRoleList(context, payload) {
            return D.select({
                ...payload
            })
        },
        selectSystemList(context, payload) {
            return D.select({
                ...payload
            })
        },
        // 更新任务
        updateAddUser(context, payload) {
            return D.edit({
                ...payload
            })
        },
        addEditMenu(context, payload) {
            return D.edit({
                ...payload
            })
        },
        deleteMenu(context, payload) {
            return D.del({
                ...payload
            })
        },
        getEmptySearch(context) {
            context.commit({
                type: 'save',
                payload: {
                    searchP: {
                        fullname: '',//用户姓名
                        usertype: '',//用户类型
                        organizationid: ''//所属组织
                    }
                }
            })
        },
        //银响力菜单角色列表
        rolelist(context, payload) {
            return D.select({
                ...payload
            })
        },
        updateUserAuth4Fp(context, payload) {
            return D.edit({
                ...payload
            })
        },

        queryRoleSys(context, payload) {
            return D.select({
                ...payload
            })
        },

        delRoleSys(context, payload) {
            return D.del({
                ...payload
            })
        },

        addRoleSys(context, payload) {
            return D.add({
                ...payload
            })
        },

    }
}
